import { FC } from 'react';
import tw from 'twin.macro';
import { LineMargin } from '../enums';
import styled from 'styled-components';

const StyledLine = styled.hr<{ $margin: string }>`
  ${tw`flex-none w-full mx-auto border-t-slate-800/10`}

  margin-bottom: ${({ $margin }) => $margin};
  margin-top: ${({ $margin }) => $margin};
`;

interface Props {
  margin?: LineMargin;
  className?: string;
}

const Line: FC<Props> = ({ margin = LineMargin.medium, className }) => (
  <StyledLine $margin={margin} className={className} />
);

export default Line;
